function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 100.663,
    height: 98.18,
    viewBox: "0 0 26.634 25.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M62.954 190.42c-7.353 0-13.317 5.963-13.317 13.318 0 5.883 3.816 10.875 9.108 12.636.665.123.88-.29.88-.64v-2.48c-3.704.806-4.475-1.57-4.475-1.57-.606-1.54-1.48-1.95-1.48-1.95-1.208-.826.092-.808.092-.808 1.338.093 2.041 1.372 2.041 1.372 1.188 2.036 3.115 1.447 3.875 1.107.12-.86.464-1.448.846-1.78-2.957-.339-6.067-1.48-6.067-6.582 0-1.455.52-2.642 1.372-3.575-.138-.336-.594-1.69.13-3.524 0 0 1.118-.357 3.663 1.365a12.77 12.77 0 0 1 3.332-.448c1.132.005 2.272.153 3.336.448 2.543-1.722 3.659-1.365 3.659-1.365.725 1.834.268 3.19.13 3.524.855.933 1.371 2.121 1.371 3.575 0 5.115-3.115 6.241-6.08 6.57.477.413.913 1.224.913 2.466v3.655c0 .354.214.77.89.639 5.287-1.763 9.098-6.754 9.098-12.635 0-7.355-5.963-13.317-13.317-13.317z",
    style: {
      strokeWidth: 1.10973
    },
    transform: "translate(-49.637 -190.42)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.0b947e9a90b3751e539f1a22d3034145.svg";
export { ForwardRef as ReactComponent };